import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";

import DefaultApiService from "../../../../infrastructure/api/default";
import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import DeleteConfirm from "../../../components/shared/Dialog/DeleteConfirm";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../components/shared/table";

const CategoryPage = () => {
  const categoryListData = useLoaderData("root");
  // اطمینان از اینکه categoryList همیشه یک آرایه است
  const categoryList = Array.isArray(categoryListData) ? categoryListData : [];
  let navigate = useNavigate();
  const pageInfo = useGetPageInfo();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
  });
  const headCells = [
    {
      id: "id",
      disablePadding: false,
      label: "ایدی",
    },
    {
      id: "title",
      disablePadding: false,
      label: "عنوان",
    },
    {
      id: "updateOn",
      type: "date",
      disablePadding: true,
      label: "تاریخ بروزرسانی",
    },
    {
      id: "description",
      disablePadding: false,
      label: "توضیحات",
    },
    {
      id: "isActive",
      type: "boolean",
      disablePadding: false,
      label: "وضعیت",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onDeleteClicked = (row) => {
    setDeleteConfirm((old) => ({ ...old, open: true, data: row }));
  };

  const confirmedDeleteCategory = () => {
    return DefaultApiService.deleteOneApi("UM/Category", {
      id: deleteConfirm.data.id,
    });
  };

  const onFetchData = () => {
    navigate();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />

        <DeleteConfirm
          message={`برای حذف دسته‌بندی "${deleteConfirm.data.title}" اطمینان دارید؟`}
          open={deleteConfirm.open}
          onClose={(loadAgain) => {
            setDeleteConfirm({
              open: false,
              data: {},
            });
            if (loadAgain) {
              navigate();
            }
          }}
          onSubmit={confirmedDeleteCategory}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Link to={"create"}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                  >
                    ایجاد دسته‌بندی
                  </Button>
                </Link>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={categoryList}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    {
                      icon: <EditIcon sx={{ width: "1rem", height: "1rem" }} />,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                    {
                      icon: (
                        <DeleteIcon sx={{ width: "1rem", height: "1rem" }} />
                      ),
                      onClick: onDeleteClicked,
                      color: "secondary",
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CategoryPage;
